// Library import
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Proptypes from 'prop-types';

// File Import
import CrossIcon from '~/images/icon/cross-gray.png';
import StarOutline from '~/images/icon/star-outline.svg';
import LeftArrow from '~/images/icon/left-arrow.png';
import MobileVactor from '~/images/icon/mobile-vactor.png';
import { postTypeName } from '@/constant/global';
import { jobHunting } from '@/constant/sections';
import { formatDate } from '@/config';

// Components Import

export const PostPreviewModal = ({ show, post, handleClose, isPreview = false }) => {
  const mapTitle = jobHunting[7];
  const [postItemSort, setPostItemSort] = useState([]);
  const [seminarItems, setSeminarItems] = useState([]);
  useEffect(() => {
    if (post?.items && post?.items instanceof Array) {
      let arrSort = [];
      let arr = [];
      post?.items.forEach((elm, idx) => {
        if (elm['title'] === '地図で見る') {
          arrSort.unshift(elm);
        } else if (elm['title'] === 'お問合せ・お申込み') {
          arrSort.push(elm);
        } else {
          arr.push(elm);
        }
      });
      arr = [...arr, ...arrSort];
      setPostItemSort(arr);
    }

    if (post?.ci_seminar_items) {
      const listCI = [];
      post?.ci_seminar_items.forEach((item) => {
        const startDate = `${formatDate(item.ci_start_date, 'YYYY-MM-DD')} ${item.ci_start_time}:${item.ci_start_minute}`;
        const endDate = `${formatDate(item.ci_end_date, 'YYYY-MM-DD')} ${item.ci_end_time}:${item.ci_end_minute}`;
        const objCI = {
          address: item.ci_address && item.ci_address !== '' ? item.ci_address : '',
          description: item.ci_description && item.ci_description !== '' ? item.ci_description : '',
          end_date: item.ci_end_date && item.ci_end_time && item.ci_end_minute && item.ci_end_date != '' ? endDate : '',
          start_date: item.ci_start_date && item.ci_start_time && item.ci_start_minute && item.ci_start_date != '' ? startDate : '',
          title: item.ci_title && item.ci_title !== '' ? item.ci_title : '',
          url: item.ci_url && item.ci_url !== '' ? item.ci_url : ''
        };
        listCI.push(objCI);
      });
      setSeminarItems(listCI);
    } else if (post.calendar_info) {
      setSeminarItems(JSON.parse(post.calendar_info).seminar_items);
    }
  }, [show]);

  const handleDescription = (description) => {
    if (!description || description.trim().length === 0) return '';

    const regex1 = /0\d{1,4}-\d{1,4}-\d{4}/g;
    const regex2 = /0120-\d{1,4}-\d{3}/g;

    description = description.replace(/</g, '&lt;').replace(regex1, (match) => {
      return `<span class='phone'>${match}</span>`;
    });

    description = description.replace(regex2, (match) => {
      return `<span class='phone'>${match}</span>`;
    });

    return description;
  };

  const showPostElement = (item) => {
    return (
      <div className='post-content-wrapper'>
        {/* Post title */}
        {item?.sub_items?.map((sub, index) => (
          <div className='post-content-inner px-3' key={index}>
            <div className='post-title p-0 py-2'>{sub?.title} </div>

            <div className='post-content p-0'>
              <div className='post-thumb'>
                {sub?.image_full_path ? (
                  <img src={sub?.image_full_path} alt='Feature thumb' />
                ) : sub?.image ? (
                  <img src={sub?.image} alt='Feature thumb' />
                ) : (
                  ''
                )}
              </div>
              <div
                className='post-desc p-0 text-start text-break'
                dangerouslySetInnerHTML={{ __html: handleDescription(sub?.description) }}></div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const showPostContent = (item, i) => {
    const displayTitle = item?.title === '自由入力' ? item?.title_free : item?.title;
    return post?.type === 'news' && post?.map_flg === 0 && item.title === mapTitle ? (
      ''
    ) : (
      <div className='post-item' key={i}>
        {/* Section title */}
        <div className='post-content'>
          {post?.type === 'case_study' ? (
            <div className='post-section-title px-3'>{displayTitle}</div>
          ) : (
            <div className='post-title position-relative'>
              <div className='post-line'></div>
              <span className='position-relative'>{displayTitle}</span>
            </div>
          )}
          {post?.type === 'case_study' && showPostElement(item)}
          {((post?.type !== 'case_study' && item?.title !== mapTitle) || (post?.type === 'news' && item?.title === mapTitle)) && (
            <div
              className='post-desc px-3 text-start text-break'
              dangerouslySetInnerHTML={{ __html: handleDescription(item?.description) }}></div>
          )}
          {(post?.type === 'job_hunting' || post?.type === 'skill_support' || post?.type === 'news') &&
            item?.title === mapTitle &&
            showMapElement(item)}
        </div>
      </div>
    );
  };

  const showMapElement = (item) => {
    return item?.map_items?.map((map, index) => (
      <div key={index} className='post-desc px-3 text-start'>
        {map &&
          map?.address &&
          map?.address?.split('　')?.map((val, idx) => (
            <div key={idx} className='text-break'>
              {val}
            </div>
          ))}
        <button className='button mb-4'>地図</button>
      </div>
    ));
  };

  return (
    <Modal show={show} onHide={handleClose} centered animation={true} className='modal-wrapper post-modal-wrapper' backdrop='static'>
      <h3 className='preview-title pt-3 text-center'>プレビュー</h3>
      <div className='post-wrapper text-center'>
        <div className={post?.url ? 'post-element post-element-url' : 'post-element'}>
          {/* Header Title */}
          <div className='header-title px-3'>{post?.title}</div>

          {/* Header Thumb */}
          <div className='header-thumb'>
            {isPreview ? (
              post?.original_image ? (
                <img src={post?.original_image} alt='Feature thumb' />
              ) : (
                ''
              )
            ) : post?.image ? (
              <img src={post?.image} alt='Feature thumb' />
            ) : (
              ''
            )}
          </div>

          {/* Tags */}
          <div className='post-header d-flex justify-content-between'>
            <ul className='tags'>
              {post?.tags?.map((tag, idx) => (
                <li key={idx} className='tag-list'>
                  {tag?.title}
                </li>
              ))}
            </ul>

            <div className='post-favorite ms-2'>
              <img src={StarOutline} alt='Star Icon' />
            </div>
          </div>

          {/* Post content */}
          {post?.items && post.items instanceof Array
            ? postItemSort && postItemSort.map((item, i) => showPostContent(item, i))
            : post.items?.map((item, i) => showPostContent(item, i))}

          {/* Calendar */}
          {seminarItems &&
            seminarItems.map((item, index) =>
              item.start_date ? (
                <div className='post-item' key={index}>
                  <div className='post-desc'>
                    <div className='post-desc'>
                      {formatDate(item.start_date, 'MM/DD HH:mm') + ' ~ ' + formatDate(item.end_date, 'MM/DD HH:mm')}
                    </div>
                    <button className='button mx-auto calendar'>カレンダーに追加</button>
                  </div>
                </div>
              ) : (
                ''
              )
            )}
        </div>

        <div className='external-links'>
          {post?.url && post?.type !== 'news' && (
            <button className='button primary mb-2' onClick={() => window.open(post?.url)}>
              この支援メニューのページへ
            </button>
          )}
          {post?.url && post?.type === 'news' && (
            <button className='button primary mb-2' onClick={() => window.open(post?.url)}>
              関連サイト・ページへ
            </button>
          )}
          {post?.type !== 'news' && <button className='button primary'>絞り込み条件の変更</button>}
        </div>

        <div className='mobile-vactor'>
          <img src={MobileVactor} alt='Mobile Vactor' />
          {/* Page title */}
          <div className='page-title'>
            <img onClick={handleClose} src={LeftArrow} alt='Left Arrow' /> {postTypeName[post?.type?.toUpperCase()]}詳細
          </div>
        </div>
      </div>

      <div className='close-modal' onClick={handleClose}>
        <img src={CrossIcon} alt='Cross icon' />
      </div>
    </Modal>
  );
};

PostPreviewModal.prototype = {
  show: Proptypes.bool,
  handleClose: Proptypes.func,
  post: Proptypes.object,
  isPreview: Proptypes.bool
};
